














































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Modal from '@/shared/components/Modal.vue';
import shortid from 'shortid';
import { required, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import Toast from '@/shared/services/toast';
import { IntentViewModel } from '@/features/bots/models/intents/intentViewModel';
import { UtteranceViewModel } from '@/features/bots/models/intents/utteranceViewModel';
import UtteranceList from '@/features/bots/components/designer/UtteranceList.vue';
import { CREATE_INTENT } from '@/store/intents/actionTypes';
import { SaveIntentViewModel } from '../../models/intents/saveIntentViewModel';

@Component({
	mixins: [
		validationMixin,
	],
	components: {
		UtteranceList,
		Modal
	},
	validations: {
		intentTitle: {
			required,
			maxLength: maxLength(50),
			intentNameValid: VuelidateUtil.intentName
		},
		intentUtterances: {
			required,
			$each: {
				text: {
					required,
					isUnique(value) {
						return !(this.$v.intentUtterances && this.$v.intentUtterances.$model.filter((utterance: any) => utterance.text === value).length > 1);
					},
				}
			}
		}
	}
})
export default class AddIntentModal extends Vue {
	@Action(CREATE_INTENT) public createIntent!: (intent: SaveIntentViewModel) => Promise<IntentViewModel>;

	public show: boolean = false;
	public isSaveInProgress: boolean = false;


	public intent: IntentViewModel;
	public intentId: string | undefined = '';
	public intentTitle: string = '';
	public intentUtterances: UtteranceViewModel[] = [];

	public showModal() {
		this.show = true;
	}

	public cancel() {
		this.$v.$reset();
		this.show = false;
		this.$emit('cancelled');
	}

	public async saveIntent() {
		this.$v.$touch();
		if (this.$v.$invalid) {
			Toast.showError('Fix the errors in red before saving');
			return;
		}
		try {
			this.isSaveInProgress = true;
			this.intent.utterances = this.intentUtterances.sort((uttOne, uttTwo) => uttOne.text.localeCompare(uttTwo.text));
			this.intent.title = this.intentTitle.trim();
			this.intent = await this.createIntent({
				title: this.intent.title,
				utterances: this.intent.utterances.map(utterance => utterance.text),
			});
			Toast.showSuccess('Saved intent');
			this.$emit('completed', this.intent);
			this.show = false;
			this.$v.$reset();
		} catch (ex: any) {
			Toast.showError(ex.message);
		} finally {
			this.isSaveInProgress = false;
		}
	}

	public addNewIntent(firstUtterance?: string) {
		this.intent = {
			id: `intent-${shortid.generate()}`,
			title: '',
			utterances: [
				{id: shortid.generate(), text: firstUtterance ? firstUtterance : ''},
			]
		} as IntentViewModel;

		this.intentId = this.intent.id;
		this.intentTitle = this.intent.title;
		this.intentUtterances = this.intent.utterances;

		this.show = true;
	}

	public getErrorMessage(): string {
		if (this.$v.intentTitle.required && !this.$v.intentTitle.intentNameValid) {
			return 'Name must only contain letters, numbers, spaces, and the characters , - _ ( )';
		}
		if (!this.$v.intentTitle.maxLength) {
			return 'Name must not be longer than 50 characters';
		}
		if (!this.$v.intentTitle.required && this.$v.intentTitle.$dirty) {
			return 'Name must not be empty';
		}

		return '';
	}
}
